import { Document, Page, Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";

import sitlogo from '../../assets/images/sitlogo.png'
Font.register({
    family: 'Poppins',
    fonts: [
        {
            src: '/fonts/Poppins-Regular.ttf',
            fontWeight: 'normal',
        },
        {
            src: '/fonts/Poppins-SemiBold.ttf',
            fontWeight: 600,
        },
        {
            src: '/fonts/Poppins-Bold.ttf',
            fontWeight: 'bold',
        },
    ],
});

// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 30,
    },
    col: {
        display: "flex",
        flexDirection: "row",
        //border: "1px solid black",
    }
});

const paginateData = (data, rowsPerPage) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += rowsPerPage) {
        chunks.push(data.slice(i, i + rowsPerPage));
    }
    return chunks;
};

const ServiceTaxReport = ({ data }) => {
    const rowsPerPage = 30;
    const pages = paginateData(data, rowsPerPage);
    return (
        <Document>
            {pages.map((pageData, pageIndex) => (
                <Page
                    key={pageIndex}
                    size="A4"
                    style={{ padding: 30, fontSize: 10, }}
                >
                    <View
                        style={{
                            flexDirection: 'column',
                            justifyContent: "space-between",
                            alignItems: "flex-start",

                        }}>
                        <Image src={sitlogo} style={{ width: "70px" }}>
                        </Image>
                    </View>

                    <View style={{ fontSize: "10px", textAlign: "center", }}>
                        <Text style={{ fontFamily: "Poppins", fontWeight: 'bold' }}>SERVICE TAX REPORT : 01-Mar-2025</Text>
                    </View>

                    <View style={[styles.col, { border: "1px solid black", fontSize: "10px", textAlign: "center", width: "100%" }]}>
                        <View style={{ borderRight: "1px solid black", width: "20%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Student_Name-Coad </Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "25%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Course_Name</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "8%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Batch</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "12%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Admission</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "10%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Batch Fees</Text>
                        </View>
                        <View style={{ borderRight: "1px solid black", width: "15%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Tax Amount</Text>
                        </View>
                        <View style={{ width: "10%" }}>
                            <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: "bold" }}>Total</Text>
                        </View>
                    </View>

                    {pageData.map((item, idx) => (
                        <View
                            key={idx}
                            style={[styles.col, { borderBottom: "1px solid black", fontSize: "10px", textAlign: "center", width: "100%" }]}
                        >
                            <View style={{ borderLeft: "1px solid black", borderRight: "1px solid black", width: "20%" }}>
                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>{item.Student_Name}</Text>
                                <Text style={{ borderTop: "1px solid black", textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>{item.Student_Code}</Text>
                            </View>

                            <View style={{ borderRight: "1px solid black", width: "25%" }}>
                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>{item.Course_Name}</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "8%" }}>
                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>{item.Batch_code} </Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "12%" }}>
                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>11-Mar-2025</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "10%" }}>
                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>0.00</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "15%" }}>
                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>0.00</Text>
                            </View>
                            <View style={{ borderRight: "1px solid black", width: "10%" }}>
                                <Text style={{ textAlign: "center", fontSize: 9, fontFamily: "Poppins", fontWeight: 500 }}>50,000</Text>
                            </View>
                        </View>
                    ))}
                </Page>
            ))}
        </Document>


    )
}

export default ServiceTaxReport